import { Injectable } from '@angular/core';
import { init as initApm } from '@elastic/apm-rum';

@Injectable({ providedIn: 'root' })
export class ApmService {
    // public apm = initApm({
    //     serviceName: 'DEV-SP-Angular-DataEntry',
    //     serverUrl: 'https://apm.signpl.com/',
    //     environment: 'development',
    //     distributedTracingOrigins: ['http://192.168.0.190:5000'],
    //     active: true,
    // });
}
